import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchApprovalCounts, APPROVALS_CHANGED_EVENT } from "@admin/services/adminApi";

// Pending counts for the Approvals sidebar badges. Refreshes on navigation
// and whenever a page dispatches APPROVALS_CHANGED_EVENT after a decision.
export function useApprovalCounts(enabled = true) {
  const [counts, setCounts] = useState({});
  const { pathname } = useLocation();

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const load = () => fetchApprovalCounts().then((c) => { if (alive) setCounts(c || {}); }).catch(() => {});
    load();
    window.addEventListener(APPROVALS_CHANGED_EVENT, load);
    return () => { alive = false; window.removeEventListener(APPROVALS_CHANGED_EVENT, load); };
  }, [enabled, pathname]);

  return counts;
}
